export default "__VITE_PUBLIC_ASSET__3e8a1822__"